import { request } from '@umijs/max';

// 全局消息实例
let messageApi: any = null;

// 初始化消息API
export const initMessageApi = (api: any) => {
  messageApi = api;
};

// 注意：错误处理逻辑已移至 requestErrorConfig.ts
// 这里只保留网络状态检测功能

// 网络状态检测
let isOnline = navigator.onLine;

// 监听网络状态变化
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    isOnline = true;
    if (messageApi) {
      messageApi.success('网络连接已恢复');
    }
  });

  window.addEventListener('offline', () => {
    isOnline = false;
    if (messageApi) {
      messageApi.warning('网络连接已断开，请检查网络设置');
    }
  });
}

// 注意：enhancedRequest 函数已被移除
// 现在直接使用 Umi 的 request 函数，错误处理由 requestErrorConfig.ts 统一管理

// 导出网络状态
export const getNetworkStatus = () => isOnline;

// 导出默认的request函数（保持向后兼容）
export { request };
